module.exports = __webpack_public_path__ + "170c7d75e6ffbe0c2bdf8285d9ae5f82.svg";